import React, { useCallback } from "react"
import { useHookstate } from "@hookstate/core"
import { Col, Row } from "react-bootstrap"
import FilePicker from "../../components/FilePicker"
import Section from "../../components/Section"
import VideoPicker from "../../components/VideoPicker"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"

const VideoSection: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const exiState = useExhibitorDataState()
    const organizationState = exiState.getOrganization()
    const organization = useHookstate(organizationState)

    const onChangeThumbnail = useCallback(
        (
            image: File,
            onUploadProgress: (progress: number) => void,
            onSuccessCallback: () => void,
            onErrorCallback: (reason: string) => void
        ) => {
            exiState
                .upload("BACKGROUND_IMAGE", image, onUploadProgress)
                .then((response) => {
                    onSuccessCallback()
                    if (response) {
                        organization.headerVideoImageFileId.set(response.fileId)
                        organization.headerVideoImageUrl.set(response.fileUrl)
                    }
                })
                .catch((reason) => onErrorCallback(reason))
        },
        [exiState, organization]
    )

    const onChangeVideo = useCallback(
        (
            image: File,
            onUploadProgress: (progress: number) => void,
            onSuccessCallback: () => void,
            onErrorCallback: (reason: string) => void
        ) => {
            exiState
                .upload("MULTIMEDIA", image, onUploadProgress)
                .then((response) => {
                    onSuccessCallback()
                    if (response) {
                        organization.headerVideoFileId.set(response.fileId)
                        organization.headerVideoUrl.set(response.fileUrl)
                    }
                })
                .catch((reason) => onErrorCallback(reason))
        },
        [exiState, organization]
    )

    const onRemoveThumbnail = useCallback(() => {
        organization.headerVideoImageFileId.set("")
        organization.headerVideoImageUrl.set("")
    }, [organization])

    const onRemoveVideo = useCallback(() => {
        organization.headerVideoFileId.set("")
        organization.headerVideoUrl.set("")
    }, [organization])

    return (
        <Section id="companyHeaderVideo" title={branding.configuration.profilePage.sctVideo.lblCompanyVideo}>
            <Row>
                <Col sm={12} md={3}>
                    <FilePicker
                        name="videoThumbnail"
                        label={branding.configuration.profilePage.sctVideo.lblThumbnail}
                        placeholderTitle={branding.configuration.profilePage.sctVideo.hntTitleThumbnail}
                        placeholderText={branding.configuration.profilePage.sctVideo.hntPropThumbnail}
                        browseLabel={branding.configuration.profilePage.sctVideo.btnBrowseFiles}
                        deleteLabel={branding.configuration.profilePage.sctVideo.btnDeleteImg}
                        value={organization.headerVideoImageUrl.get()}
                        onChangeImage={onChangeThumbnail}
                        onRemoveImage={onRemoveThumbnail}
                    />
                </Col>
                <Col sm={12} md={9}>
                    <VideoPicker
                        name="video"
                        label={branding.configuration.profilePage.sctVideo.lblVideo}
                        placeholderTitle={branding.configuration.profilePage.sctVideo.hntTitleVideo}
                        placeholderText={branding.configuration.profilePage.sctVideo.hntPropVideo}
                        value={organization.headerVideoUrl.get()}
                        onChangeVideo={onChangeVideo}
                        onRemoveVideo={onRemoveVideo}
                    />
                </Col>
            </Row>
        </Section>
    )
}

export default VideoSection
